import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import NavLeftList from './NavLeftList';
import NavRightList from './NavRightList';
import PropTypes from 'prop-types';
import { isCustomer } from 'utils/helpers';
import SelectField from 'components/EnhancedSelectField';
import { MenuItem } from '@mui/material';
import * as moduleService from 'services/moduleService';
import CircularProgress from '@mui/material/CircularProgress';

class Header extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedOption: 'flm',
      modules: [],
      isLoading: true,
      responseError: {
        isError: false,
        message: ''
      }
    };
  }

  componentDidMount() {
    const sidebarToggler = this.sidebarBtn;
    const $sidebarToggler = $(sidebarToggler);
    const $body = $('#body');

    $sidebarToggler.on('click', (e) => {
      // _sidebar.scss, _page-container.scss
      $body.toggleClass('sidebar-mobile-open');
    });

    this.loadModules();
  }

  loadModules = () => {
    this.props
      .dispatch(moduleService.getAllowedModules())
      .then(modules => {
        this.setState({
          modules,
          isLoading: false,
          selectedOption: modules.length > 0 ? modules[0].id : '',
          responseError: {
            isError: false
          }
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          responseError: {
            isError: true,
            message: error.message
          }
        });
      });
  };

  handleSelectChange = (event) => {
    const selectedModule = event.target.value;
    this.setState({
      selectedOption: selectedModule,
      isLoading: true
    });

    this.props
      .dispatch(moduleService.updateSelectedModule(selectedModule))
      .then(() => {
        this.setState({
          isLoading: false,
          responseError: {
            isError: false
          }
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          selectedOption: this.state.selectedOption, // Revert to previous selection
          responseError: {
            isError: true,
            message: error.message
          }
        });
      });
  };

  render() {
    const { colorOption, user } = this.props;
    const { modules, isLoading } = this.state;

    return (
      <section className="app-header">
        <div
          className={classnames('app-header-inner', {
            'bg-color-light':
              ['11', '12', '13', '14', '15', '16', '21'].indexOf(colorOption) >=
              0,
            'bg-color-dark': colorOption === '31',
            'bg-color-primary': ['22', '32'].indexOf(colorOption) >= 0,
            'bg-color-success': ['23', '33'].indexOf(colorOption) >= 0,
            'bg-color-info': ['24', '34'].indexOf(colorOption) >= 0,
            'bg-color-warning': ['25', '35'].indexOf(colorOption) >= 0,
            'bg-color-danger': ['26', '36'].indexOf(colorOption) >= 0,
          })}
        >
          <div className="d-lg-none d-xl-none float-left">
            <a
              className="md-button header-icon toggle-sidebar-btn"
              ref={(c) => {
                this.sidebarBtn = c;
              }}
            >
              <i className="material-icons">menu</i>
            </a>
          </div>

          <div className="brand d-none d-lg-inline-block d-xl-inline-block">
            <h2>
              <Link
                to={
                  process.env.REACT_APP_IS_SHOPIFY === 'true'
                    ? '/app/settings'
                    : isCustomer(user)
                      ? '/'
                      : '/app/orders/pending'
                }
              >
                <img
                  src="/assets/images/wakilni-logo-v2.png"
                  height="22"
                  alt="{APPCONFIG.brand}"
                />
              </Link>
            </h2>
          </div>

          <div className="top-nav-left d-none d-lg-inline-block d-xl-inline-block">
            <NavLeftList />
          </div>

          <div className="top-nav-left d-lg-inline-block d-xl-inline-block" style={{
            alignItems: 'center',
            height: '100%',
            justifyContent: 'center',
            flex: 1,
            marginLeft: '16px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                modules.length > 0 && (
                  <SelectField
                    floatingLabelText=""
                    value={this.state.selectedOption}
                    onChange={this.handleSelectChange}
                    variant="standard"
                    fullWidth
                    sx={{
                      color: 'inherit',
                      fontSize: { xs: '14px', lg: '16px' },
                      width: { xs: '140px', lg: '220px' },
                      minWidth: { xs: '140px', lg: '220px' }
                    }}
                  >
                    {modules.map(module => (
                      <MenuItem key={module.id} value={module.id}>
                        {module.name}
                      </MenuItem>
                    ))}
                  </SelectField>
                )
              )}
            </div>
          </div>

          <div className="top-nav-right">
            <NavRightList />
          </div>
        </div>
      </section>
    );
  }
}

Header.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  colorOption: state.settings.colorOption,
  user: state.auth.user
});

export default connect(mapStateToProps)(Header);
